import { render, staticRenderFns } from "./MapSettingFab.vue?vue&type=template&id=36fbc4b4&lang=pug&"
import script from "./MapSettingFab.vue?vue&type=script&lang=js&"
export * from "./MapSettingFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MapSettingFab.vue"
export default component.exports